import Header from "./components/Header";
import Hero from "./components/Hero";
import Examples from "./components/Examples";
import Situations from "./components/Situations";
import ServiceContent from "./components/ServiceContent";
import Flow from "./components/Flow";
import Pricing from "./components/Pricing";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-cream">
      <Header />
      <main>
        <Hero />
        <Examples />
        <Situations />
        <ServiceContent />
        <Flow />
        <Pricing />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}